import {ImageLoader} from '@lib/ImageLoader';
import {IPreloader} from '@services/types';

export class Preloader implements IPreloader {
  static singleton: Preloader;
  private loader: ImageLoader;

  static create() {
    if (Preloader.singleton) {
      return Preloader.singleton;
    }
    return (Preloader.singleton = new Preloader());
  }

  constructor() {
    this.loader = ImageLoader.create();
  }

  public async load(urls: string[]) {
    urls.map((url) => {
      this.loader.add(url);
    });
    await this.loader.load();
  }

  public async get(url: string) {
    const ret = await this.loader.get(url);
    return ret;
  }
}
